/**
 * naegift-main 전용 사용자 대면 메시지
 *
 * 사용처 (main 프로젝트 내):
 * - storeContent.js: 상점 정보 입력 (회원가입 1단계)
 * - userContent.js: 관리자 정보 입력 (회원가입 2단계)
 * - idSearch.js: 아이디 찾기
 * - pwdSearch.js: 비밀번호 찾기
 * - AccountValidationPopup.js: 계좌 실명 조회 팝업
 * - userSignUp.js: 약관 동의 (회원가입 step1)
 *
 * 사용법:
 *   import { messages } from '../../data/messages';
 *   const t = messages[language];  // language: 'ko' | 'en'
 *   setModalInfo({ ...modalInfo, mainMsg: t.agreeRequired });
 */

export const messages = {
  ko: {
    // === 공통 ===
    apiError: 'API 서버에러입니다. 잠시 후 다시 시도해주세요.',
    requestError: '요청 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
    adminNotFound: '상점 관리자 정보가 없습니다.',
    agreeRequired: '수신동의 해주세요.',
    termsAgreeRequired: '약관 동의를 해주세요.',


    // === userContent.js (관리자 정보) ===
    idRule: '아이디는 영문 소문자 5~15자 이내로 해주세요. (영문 소문자 필수)',
    idDuplicate: '중복된 아이디 입니다. 다른 아이디를 넣어주세요',
    idCheckRequired: '아이디 중복확인 해주세요.',
    idAvailable: '사용할 수 있는 아이디입니다.',
    idRequired: '아이디를 입력해 주세요.',
    passwordRule:
      '영문, 숫자, 특수문자 중 2가지 이상 조합 8~16자.\n3자 이상 동일한 숫자/문자는 사용이 불가합니다.',
    passwordMismatch: '비밀번호가 일치하지 않습니다(대소문자 구분).',
    passwordRequired: '비밀번호를 입력해 주세요.',
    passwordConfirmRequired: '비밀번호 확인 해주세요.',
    nameRequired: '이름을 입력해 주세요.',
    nameNoNumber: '이름에는 숫자를 입력할 수 없습니다.',
    birthdayRequired: '생년월일을 입력해 주세요.',
    emailRequired: '이메일을 입력해 주세요.',
    emailInvalid: '이메일 주소가 유효하지 않습니다.',
    emailAuthRequired: '이메일 인증 해주세요.',
    emailAuthGetRequired: '이메일 인증번호받기를 해주세요.',
    emailAuthError: '이메일 인증번호가 다릅니다. 다시 해주세요',
    emailAuthSuccess: '이메일 인증번호가 확인 되었습니다.',
    emailAuthCheck: '인증번호를 메일에서 확인하고 넣어주세요!',
    emailEmptyHint: '이메일 주소를 입력하세요.',
    emailSpaceHint: '이메일의 공백은 자동으로 제거됩니다.',
    smsRequired: '전화번호 인증번호를 받고 인증하기를 하세요.',
    smsAuthGetRequired: '전화번호 인증번호받기를 해주세요.',
    smsAuthError: '전화번호 인증번호가 다릅니다. 다시 해주세요',
    smsAuthSuccess: '전화번호 인증번호가 확인 되었습니다.',
    smsAuthCheck: '인증번호를 SMS로 확인하고 넣어주세요.',
    phoneFormat:
      '전화번호를 숫자(3자리)-숫자(4자리)-숫자(3자리)로 넣어주세요.',
    phoneFormatShort:
      '전화번호를 숫자(3자리)-숫자(4자리)-숫자(3자리)로 넣어주세요.',
    addressRequired: '주소를 입력해 주세요.',
    detailAddrRequired: '상세주소를 입력해 주세요.',
    sendingEmail: '메일을 보내는 중입니다.....',
    sendingSms: 'SMS를 보내는 중입니다.....',
    idFormatHint: '영문 소문자, 숫자만 입력하세요.',
    passwordFormatHint: '영문/숫자/특수문자만 입력 가능합니다.',
    digitsOnly: '숫자만 입력할 수 있습니다.',
    inputInvalid: '사용 불가',

    // === storeContent.js (상점 정보) ===
    storeRegistering: '회원가입 처리 중입니다.....',
    sendingMailSms: '메일과 SMS를 보내는 중입니다.....',
    adminDataRequired:
      '관리자 정보가 없습니다. 이전 단계에서 인증을 완료해 주세요.',
    storeDataRequired:
      '상점 정보가 없습니다. 이전 단계에서 상점 정보를 입력해 주세요.',
    storeNameRequired: '상점명을 입력해 주세요.',
    bizNumFormat: '사업자등록번호를 3-2-5 자리로 입력해 주세요.',
    bizNumVerifyRequired: '사업자등록번호를 조회/인증해 주세요.',
    bizNumVerifyBeforeAccount:
      '계좌 인증 전에 사업자등록번호 조회를 먼저 진행해 주세요.',
    bizNumVerifyAll: '사업자등록번호를 3-2-5 자리로 모두 입력해 주세요.',
    bizNumNtsError: '국세청 응답이 올바르지 않습니다. 잠시 후 다시 시도해 주세요.',
    bizNumNotRegistered: '국세청에 등록되지 않은 사업자등록번호입니다.',
    bizNumClosed: '폐업된 사업자등록번호는 가입할 수 없습니다.',
    bizNumVerifyFail:
      '사업자번호 조회 실패(CORS/네트워크). 잠시 후 다시 시도해 주세요.',
    bizNumVerifySuccess: '사업자번호 인증 완료',
    bizNumVerifySuccessFormat: '사업자번호 인증 완료 ({status})',
    bizNumStatusDefault: '상태확인',
    phoneRequired: '전화번호를 입력해 주세요.',
    addressRequiredStore: '주소를 입력해 주세요.',
    bankRequired: '입금받을 은행을 선택해 주세요.',
    accountNoRequired: '입금받을 계좌번호를 입력해 주세요.',
    accountNoFormat: '입금받을 계좌번호는 "-" 없이 숫자만 넣어주세요.',
    accountHolderRequired: '예금주를 입력해 주세요.',
    accountRevalidateCorporate:
      '법인사업자는 법인 계좌 인증이 필요합니다. 계좌 인증을 다시 진행해 주세요.',
    accountRevalidatePersonal:
      '사업자 유형이 변경되었습니다. 계좌 인증을 다시 진행해 주세요.',
    imageSizeLimit: '이미지 파일 크기는 3MByte를 초과할 수 없습니다.',
    representativeNameRequired: '대표자명을 입력해 주세요.',
    bizCertFileSizeLimit: '사업자등록증 파일 크기는 10MByte를 초과할 수 없습니다.',
    bizCertFileRequired: '사업자등록증을 올려 주세요.',
    accountPlaceholder: '계좌 실명 조회 후 자동 입력됩니다.',
    postalCodeRequiredStore:
      '우편번호를 입력해 주세요. 주소 찾기 버튼을 눌러 주소를 검색해 주세요.',
    roadAddressRequiredStore:
      '도로명주소를 입력해 주세요. 주소 찾기 버튼을 눌러 주소를 검색해 주세요.',
    jibunAddressRequiredStore:
      '지번주소를 입력해 주세요. 주소 찾기 버튼을 눌러 주소를 검색해 주세요.',
    phoneFormatStore:
      '전화번호를 올바른 형식으로 입력해 주세요.\n(예: 02-123-4567, 032-517-1642, 010-1234-5678)',

    // === idSearch.js ===
    nameRequiredSearch: '이름을 입력하세요.',
    emailRequiredSearch: '이메일 주소를 입력하세요.',
    searchingId: '아이디를 찾아 메일을 발송중입니다.....',

    // === pwdSearch.js ===
    userIdRequired: '사용자 아이디를 입력하세요.',
    searchingPwd: '비밀번호를 재발급하여 메일을 발송중입니다.....',

    // === AccountValidationPopup.js ===
    accountValidationSuccess: '계좌 유효성 검증이 완료되었습니다.',
    accountValidationFail: '계좌 유효성 검증에 실패했습니다.',
    accountValidationError: '계좌 유효성 검증 중 오류가 발생했습니다.',
    accountValidationFailShort: '계좌 유효성 검증 실패',
    accountSafeRegistered: '계좌가 안전하게 등록되었습니다.',
    accountMismatch: '계좌 정보가 일치하지 않습니다.',
    accountValidationTitle: '은행 계좌 인증을 진행해 주세요.',
    accountValidationDesc1: '회원님의 실명과 계좌에 등록된 이름이 일치해야',
    accountValidationDesc2: '인증이 가능합니다.',
    nameLabel: '이름',
    birthLabel: '생년월일',
    yearPlaceholder: '연도',
    monthPlaceholder: '월',
    dayPlaceholder: '일',
    bankLabel: '은행 (선택)',
    bankSelectNone: '선택 안함',
    accountNoLabel: '계좌번호',
    close: '닫기',
    confirm: '확인',
    verifying: '검증 중...',
    accountVerifying: '계좌 실명 조회 중...',
    accountVerifyingDesc: '계좌 유효성 검증을 진행 중입니다...',
    nameLabelShort: '이름',
    birthLabelShort: '생년월일',
    bankLabelShort: '은행',
    accountNoLabelShort: '계좌번호',
    corpAccountValidationTitle: '법인 계좌 인증을 진행해 주세요.',
    corpAccountValidationDesc1: '법인 명의 계좌와 조회한 사업자등록번호가',
    corpAccountValidationDesc2: '일치해야 인증이 가능합니다.',
    bizNoLabel: '사업자등록번호',
    bizNoLabelShort: '사업자번호',
    corpHolderPlaceholder: '법인명을 입력해 주세요. 예) (주)내기프트',
    corpHolderHint: '통장에 표시된 법인명으로 입력해 주세요.',
  },
  en: {
    // === 공통 ===
    apiError: 'API server error. Please try again later.',
    requestError: 'An error occurred while processing your request. Please try again later.',
    adminNotFound: 'Store administrator information not found.',
    agreeRequired: 'Please agree to receive notifications.',
    termsAgreeRequired: 'Please agree to the terms.',


    // === userContent.js ===
    idRule: 'ID must be 5-15 lowercase letters and numbers (lowercase required).',
    idDuplicate: 'This ID is already in use. Please use a different ID.',
    idCheckRequired: 'Please check for duplicate ID.',
    idAvailable: 'This ID is available.',
    idRequired: 'Please enter your ID.',
    passwordRule:
      'Password must be 8-16 characters with at least 2 of: letters, numbers, special characters.',
    passwordMismatch: 'Passwords do not match (case sensitive).',
    passwordRequired: 'Please enter your password.',
    passwordConfirmRequired: 'Please confirm your password.',
    nameRequired: 'Please enter your name.',
    nameNoNumber: 'Numbers are not allowed in name.',
    birthdayRequired: 'Please enter your date of birth.',
    emailRequired: 'Please enter your email.',
    emailInvalid: 'Invalid email address.',
    emailAuthRequired: 'Please verify your email.',
    emailAuthGetRequired: 'Please request email verification code.',
    emailAuthError: 'Email verification code does not match. Please try again.',
    emailAuthSuccess: 'Email verification complete.',
    emailAuthCheck: 'Check your email for the verification code.',
    emailEmptyHint: 'Please enter your email address.',
    emailSpaceHint: 'Spaces in email will be automatically removed.',
    smsRequired: 'Please verify your phone number.',
    smsAuthGetRequired: 'Please request SMS verification code.',
    smsAuthError: 'SMS verification code does not match. Please try again.',
    smsAuthSuccess: 'Phone verification complete.',
    smsAuthCheck: 'Check your SMS for the verification code.',
    phoneFormat:
      'Enter phone number as XXX-XXXX-XXXX (3-4-4 digits).',
    phoneFormatShort:
      'Enter phone number as XXX-XXXX-XXXX (3-4-4 digits).',
    addressRequired: 'Please enter your address.',
    detailAddrRequired: 'Please enter your detailed address.',
    sendingEmail: 'Sending email.....',
    sendingSms: 'Sending SMS.....',
    idFormatHint: 'Lowercase letters and numbers only.',
    passwordFormatHint: 'Letters, numbers, and special characters only.',
    digitsOnly: 'Numbers only.',
    inputInvalid: 'Invalid',

    // === storeContent.js ===
    storeRegistering: 'Processing registration.....',
    sendingMailSms: 'Sending email and SMS.....',
    adminDataRequired:
      'Admin information not found. Please complete verification in the previous step.',
    storeDataRequired:
      'Store information not found. Please enter store information in the previous step.',
    storeNameRequired: 'Please enter store name.',
    bizNumFormat: 'Enter business registration number as XXX-XX-XXXXX.',
    bizNumVerifyRequired: 'Please verify your business registration number.',
    bizNumVerifyBeforeAccount:
      'Please verify your business registration number before account verification.',
    bizNumVerifyAll: 'Please enter full business registration number.',
    bizNumNtsError: 'National Tax Service response error. Please try again later.',
    bizNumNotRegistered: 'Business number not registered with NTS.',
    bizNumClosed: 'Closed business numbers cannot register.',
    bizNumVerifyFail:
      'Business number verification failed (CORS/network). Please try again later.',
    bizNumVerifySuccess: 'Business number verification complete.',
    bizNumVerifySuccessFormat: 'Business number verification complete ({status})',
    bizNumStatusDefault: 'Status',
    phoneRequired: 'Please enter phone number.',
    addressRequiredStore: 'Please enter address.',
    bankRequired: 'Please select bank.',
    accountNoRequired: 'Please enter account number.',
    accountNoFormat: 'Enter account number without "-" (numbers only).',
    accountHolderRequired: 'Please enter account holder name.',
    accountRevalidateCorporate:
      'Corporate businesses require corporate account verification. Please verify your account again.',
    accountRevalidatePersonal:
      'Your business type has changed. Please verify your account again.',
    imageSizeLimit: 'Image file size cannot exceed 3MB.',
    representativeNameRequired: 'Please enter representative name.',
    bizCertFileSizeLimit: 'Business registration file size cannot exceed 10MB.',
    bizCertFileRequired: 'Please upload your business registration certificate.',
    accountPlaceholder: 'Will be filled after account verification.',
    postalCodeRequiredStore:
      'Please enter postal code. Use Search to find your address.',
    roadAddressRequiredStore:
      'Please enter road address. Use Search to find your address.',
    jibunAddressRequiredStore:
      'Please enter jibun address. Use Search to find your address.',
    phoneFormatStore:
      'Please enter phone number in correct format.\n(e.g. 02-123-4567, 032-517-1642, 010-1234-5678)',

    // === idSearch.js ===
    nameRequiredSearch: 'Please enter your name.',
    emailRequiredSearch: 'Please enter your email address.',
    searchingId: 'Searching for ID and sending email.....',

    // === pwdSearch.js ===
    userIdRequired: 'Please enter your user ID.',
    searchingPwd: 'Resetting password and sending email.....',

    // === AccountValidationPopup.js ===
    accountValidationSuccess: 'Account verification complete.',
    accountValidationFail: 'Account verification failed.',
    accountValidationError: 'An error occurred during account verification.',
    accountValidationFailShort: 'Account verification failed',
    accountSafeRegistered: 'Your account has been safely registered.',
    accountMismatch: 'Account information does not match.',
    accountValidationTitle: 'Please complete bank account verification.',
    accountValidationDesc1: 'Your registered name must match the name on the account',
    accountValidationDesc2: 'for verification to succeed.',
    nameLabel: 'Name',
    birthLabel: 'Date of birth',
    yearPlaceholder: 'Year',
    monthPlaceholder: 'Month',
    dayPlaceholder: 'Day',
    bankLabel: 'Bank (optional)',
    bankSelectNone: 'None',
    accountNoLabel: 'Account number',
    close: 'Close',
    confirm: 'Confirm',
    verifying: 'Verifying...',
    accountVerifying: 'Verifying account...',
    accountVerifyingDesc: 'Account verification in progress...',
    nameLabelShort: 'Name',
    birthLabelShort: 'Date of birth',
    bankLabelShort: 'Bank',
    accountNoLabelShort: 'Account number',
    corpAccountValidationTitle: 'Please complete corporate account verification.',
    corpAccountValidationDesc1: 'The corporate account must match the verified',
    corpAccountValidationDesc2: 'business registration number.',
    bizNoLabel: 'Business registration number',
    bizNoLabelShort: 'Business no.',
    corpHolderPlaceholder: 'Enter the company name, e.g. Naegift Co., Ltd.',
    corpHolderHint: 'Enter the company name as shown on the bank account.',
  },
};

/**
 * 메시지 사용처 맵 (참고용)
 *
 * userContent.js:
 *   - agreeRequired, idRule, idDuplicate, idCheckRequired, idAvailable
 *   - passwordRule, passwordMismatch, nameRequired, birthdayRequired
 *   - emailRequired, emailInvalid, emailAuthRequired, emailAuthGetRequired
 *   - emailAuthError, emailAuthSuccess, emailAuthCheck, smsAuthGetRequired
 *   - smsAuthError, smsAuthSuccess, smsAuthCheck, smsRequired
 *   - phoneFormat, addressRequired, detailAddrRequired
 *   - sendingEmail, sendingSms, apiError
 *   - idFormatHint, passwordFormatHint, digitsOnly, inputInvalid
 *
 * storeContent.js:
 *   - accountNoFormat, apiError, sendingMailSms, storeRegistering
 *   - phoneFormat, storeNameRequired, bizNumFormat, bizNumVerifyRequired
 *   - phoneRequired, addressRequiredStore, bankRequired
 *   - accountNoRequired, accountHolderRequired, adminDataRequired
 *   - imageSizeLimit, accountPlaceholder, bizNumVerifyAll, bizNumNtsError
 *   - bizNumNotRegistered, bizNumClosed, bizNumVerifyFail, bizNumVerifySuccess
 *   - digitsOnly
 *
 * idSearch.js:
 *   - nameRequiredSearch, emailRequiredSearch, searchingId
 *   - emailInvalid, adminNotFound, requestError
 *
 * pwdSearch.js:
 *   - userIdRequired, nameRequiredSearch, emailRequiredSearch
 *   - searchingPwd, emailInvalid, adminNotFound, requestError
 *
 * AccountValidationPopup.js:
 *   - accountValidationSuccess, accountValidationFail, accountValidationError
 *
 * userSignUp.js:
 *   - termsAgreeRequired
 *
 * 참고: 현재 컴포넌트들은 아직 하드코딩된 문자열 사용 중.
 *       messages.js는 메시지 목록 정리 및 향후 통합용.
 */
